/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MailIcon16Solid = forwardRef('MailIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 2A2.5 2.5 0 0 0 1 4.5v6A2.5 2.5 0 0 0 3.5 13h9a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 12.5 2h-9Zm.696 2.803a.75.75 0 0 0-.89 1.207l3.11 2.296a2.75 2.75 0 0 0 3.3-.026l2.988-2.277a.75.75 0 0 0-.91-1.193L8.808 7.088a1.25 1.25 0 0 1-1.5.011l-3.11-2.296Z" })));
});
